import api from '@/apis/di/commercialBankAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';
import indexedDB from '@/commons/indexedDB';

// Combo grid ngân hàng
export const useCommercialBankComboGrid = (comboboxDataRemote, comboboxLoadData) => {
    const { proxy } = getCurrentInstance();
    const { extendFilter } = usefilterActionCombo();
    // func call api lấy dữ liệu combo
    const onCommercialBankComboboxLoadData = (payload, row, column) => {
        let ors = [{ Field: 'inactive', Operator: 'NULL' }];
        let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
        payload.filter = extendFilter(payload.filter, extend);
        payload.sort = 'bank_code';
        if (payload.columns && !payload.columns.includes('bank_name')) {
            payload.columns += ',bank_name';
        }
        if (payload.columns && !payload.columns.includes('inactive')) {
            payload.columns += ',inactive';
        }
        return comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
    };

    // config columns combo
    const commercialBankComboConfig = {
        data: comboboxDataRemote,
        columns: [
            {
                title: 'Mã ngân hàng',
                dataField: 'bank_code',
                width: 120,
                filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
            },
            {
                title: 'Tên ngân hàng',
                dataField: 'bank_name',
                width: 480,
                filterOperator: proxy.$ms.constant.FilterOperator.Contains,
            },
        ],
        displayField: 'bank_name',
        valueField: 'bank_code',
        queryMode: 'remote',
        quickSearch: 'CommercialBankQuickSearch',
        dropdownWidth: 600,
        comboboxLoadData: onCommercialBankComboboxLoadData,
        rules: [],
    };

    return {
        commercialBankComboConfig,
        onCommercialBankComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
    };
};
